import React from 'react';
import './WhereWeWork.css';
import afgMap from '../images/slider2_education.jpg';

const Education: React.FC = () => {
  const scopeOfWork = [
    {
      title: 'Education',
      description: 'Providing inclusive, high-quality educational programs to empower Afghan communities and bridge educational gaps.',
      icon: 'fas fa-graduation-cap' // Education-related icon
    }
  ];

  return (
    <div className="where-we-work-page">

      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>Our Integrated Approach to Education</h2>
            <p>NORA operates educational programs across all 34 provinces of Afghanistan through experienced and dedicated teams</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA Educational Program Coverage" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>

      {/* Scope of Work Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            {scopeOfWork.map((item, index) => (
              <div key={index} className="scope-card">
                <div className="scope-card-header">
                  <i className={item.icon}></i>
                  <h3><strong>Our Integrated Approach to Education</strong></h3>
                </div>
                <p className="scope-card-description">
                  <strong>Education is the cornerstone of social development and sustainable progress.</strong> 
                  <br/><br/>
                  In Afghanistan, many women, children, youth, and adults still face significant barriers to accessing quality education due to poverty, lack of resources, and insufficient educational infrastructure. This educational gap limits opportunities for personal growth, economic participation, and societal development.
                  <br/><br/>
                  <strong>Our institute is committed to providing inclusive, high-quality educational programs that empower communities and bridge these gaps.</strong> We focus on creating learning opportunities for all Afghans, regardless of age, gender, or location.
                  <br/><br/>
                  <strong><h3>Our integrated educational initiatives include:</h3></strong>
                  <br/><br/>
                  <strong>1. Access to Learning Centers:</strong> Establishing and supporting schools, learning centers, and educational facilities in underserved, remote, and marginalized areas to ensure physical access to education for all communities.
                  <br/><br/>
                  <strong>2. Modern Curriculum Development:</strong> Creating and implementing contemporary curricula that combine academic knowledge with practical, market-relevant skills to prepare students for employment and entrepreneurship in a changing economy.
                  <br/><br/>
                  <strong>3. Teacher Training & Capacity Building:</strong> Conducting comprehensive professional development programs for educators to ensure high-quality instruction, innovative teaching methodologies, and effective classroom management.
                  <br/><br/>
                  <strong>4. Digital Literacy & Technology Integration:</strong> Promoting digital skills development and providing access to educational technology to enhance learning opportunities and prepare students for participation in the digital age.
                  <br/><br/>
                  <strong>5. Community Engagement & Awareness:</strong> Implementing outreach programs to raise awareness about the importance of education, with special focus on increasing enrollment and retention of girls, women, and other marginalized groups.
                  <br/><br/>
                  <strong>6. Inclusive & Lifelong Learning:</strong> Developing educational programs for diverse age groups—from early childhood education to adult literacy—ensuring learning opportunities throughout the lifespan.
                  <br/><br/>
                  <strong>7. Educational Resource Provision:</strong> Supplying schools and learning centers with essential educational materials, textbooks, and learning resources to create conducive learning environments.
                  <br/><br/>
                  <strong>Our Goal:</strong> To create a society where every Afghan has equal access to quality education, enabling them to reach their full potential, develop critical thinking skills, and contribute positively to their communities and the nation's development.
                  <br/><br/>
                  <strong>A Call for Partnership</strong>
                  <br/><br/>
                  We invite domestic and international donors and organizations to support our educational programs, helping us expand access, improve quality, and empower the next generation of Afghan leaders and professionals. Your partnership is crucial to building educational infrastructure, training teachers, and creating sustainable learning ecosystems.
                  <br/><br/>
                  <strong>Through joint collaboration, we can transform Afghanistan's educational landscape and build a future where knowledge empowers every citizen to participate in building a prosperous, peaceful nation.</strong>
                  <br/><br/>
                  <strong>Your investment in education today will shape Afghanistan's leaders of tomorrow.</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Education;